/** The passage at the reading line, or the first passage before review starts. */
export function activeChangeIndex(tops: readonly number[], readingLine: number, atEnd = false): number {
  if (atEnd) return Math.max(0, tops.length - 1);
  let active = 0;
  for (let index = 0; index < tops.length; index++) {
    if (tops[index]! > readingLine) break;
    active = index;
  }
  return active;
}
